/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, getProp, $Sprite, $SetVisibility} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import type {SpinBtnMode} from './SpinBtn';

export type BtnOuterProps = CanBeSignals<{
    mode: SpinBtnMode;
}>;

export const $BtnOuter: FC<BtnOuterProps> = (props) => {
    const outerSelect = Store.computed(() => {
        switch (getProp(props.mode)) {
            case 'autoplay':
                return 'autoplay';
            case 'free_spins':
                return 'free_spins';
            default:
                return 'hold';
        }
    });

    return <$SetVisibility selector={outerSelect}>
        <$Sprite name='hold' anchor={0.5} texture='outer_hold_sys_ui'/>
        <$Sprite name='free_spins' anchor={0.5} texture='outer_free_spins_sys_ui'/>
        <$Sprite name='autoplay' anchor={0.5} texture='outer_autoplay_sys_ui'/>
    </$SetVisibility>;
};